var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#121212",
    stroke: "#232323"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5926 26.9185L28.8603 31.652C28.7923 31.7385 28.7055 31.8083 28.6066 31.8564C28.5077 31.9045 28.3991 31.9296 28.2891 31.9297H26.8144C26.6619 31.9297 26.5777 31.7545 26.6711 31.6338L29.955 27.4692H16.1821C16.0819 27.4692 16 27.3873 16 27.2871V25.9217C16 25.8215 16.0819 25.7396 16.1821 25.7396H32.0191C32.629 25.7396 32.9681 26.4405 32.5926 26.9185Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1574 22.0112L19.8897 17.2776C19.9577 17.1912 20.0445 17.1214 20.1434 17.0733C20.2423 17.0252 20.3509 17.0001 20.4609 17H21.9356C22.0881 17 22.1723 17.1752 22.0789 17.2958L18.795 21.4605H32.5679C32.6681 21.4605 32.75 21.5424 32.75 21.6426V23.008C32.75 23.1081 32.6681 23.1901 32.5679 23.1901H16.7309C16.121 23.1901 15.7819 22.4891 16.1574 22.0112Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwap);
export default __webpack_public_path__ + "static/media/icon_swap.da8c21bba25be119f9872211fb53a8ad.svg";
export { ForwardRef as ReactComponent };